export const TRANSLATIONS_TA = {
    letsmake:"உங்கள் வணிகத்தை உருவாக்குவோம்",
    moreprofit:"அதிக லாபம்",
    createaccount:"பிளானிகோவுடன் புதிய கணக்கை உருவாக்கவும்",
    getstart:"தொடங்கவும்",
    support:"ஆதரவு",
    toservice:"சேவை விதிமுறைகள்",
    ppolicy:"தனியுரிமைக் கொள்கை",
    siginbtn:"உள்நுழைக",
    nextgen:"அடுத்த தலைமுறை",
    insaletec: "in Sale Technologies",
    sintoacc: "உங்கள் கணக்கில் உள்நுழைக",
    formfield: {
        email: "மின்னஞ்சல் முகவரி",
        pass: "கடவுச்சொல்",
        forgetpw: "கடவுச்சொல்லை மறந்து"
    },
    noaccyet: "இன்னும் கணக்கு இல்லையா?",
    cnewacc: "புதிய கணக்கை உருவாக்க",
};